import vec2 from '@/helpers/vec2'

export default {
  namespaced: true,
  getters: {

  },
  state: {
    selection: {
      points: [],
      bones: [],
      roots: []
    }
  },
  mutations: {
    select (state, { name, selection }) {
      state.selection[name] = selection
    },
    deselect (state, { name }) {
      state.selection[name] = []
    }
  },
  actions: {
    removeRootAt ({ commit, state }, { index }) {
      commit('select', { name: 'roots', selection: state.selection.roots.filter((boneIndex) => boneIndex !== index) })
      commit('crop/removeRootAt', { index }, { root: true })
    },
    removeBoneAt ({ commit, state }, { index }) {
      commit('select', { name: 'bones', selection: state.selection.bones.filter((boneIndex) => boneIndex !== index) })
      commit('crop/removeBoneAt', { index }, { root: true })
    },
    movePointsBy ({ commit, state }, { move }) {
      commit('crop/moveBonePointsBy', { points: state.selection.points, move }, { root: true })
    },
    selectNearestPointOrDeselectAt ({ commit, rootState }, { radius, position, all }) {
      const points = []
      for (let index = 0; index < rootState.crop.data.bones.length; index++) {
        const bone = rootState.crop.data.bones[index]
        const startDistance = vec2.distanceBetween(bone.start, position)
        const endDistance = vec2.distanceBetween(bone.end, position)
        if (startDistance < radius) {
          points.push({ index, joint: 'start', distance: startDistance })
        } else if (endDistance < radius) {
          points.push({ index, joint: 'end', distance: endDistance })
        }
      }
      if (points.length === 0) {
        commit('deselect', { name: 'points' })
        commit('deselect', { name: 'bones' })
        return
      }
      const selection = points
        .sort((a, b) => a.distance - b.distance)
        .map(({ index, joint }) => ({ index, joint }))

      const pointSelection = all ? selection : selection.slice(0, 1)
      const boneSelection = pointSelection.map(({ index }) => index)
      commit('select', { name: 'points', selection: pointSelection })
      commit('select', { name: 'bones', selection: boneSelection })
    },
    select ({ commit }, { name, selection }) {
      commit('select', { name, selection })
    },
    deselect ({ commit }, { name }) {
      commit('deselect', { name })
    },
    clear ({ commit }) {
      commit('deselect', { name: 'points' })
      commit('deselect', { name: 'bones' })
      commit('deselect', { name: 'roots' })
    }
  }
}
